import Drawer from 'components/commons/drawer'
import Spinner from 'components/commons/spinner'
import { formatDateMoment } from 'utils/utils'

export const PreviewInternalMovement = ({ show, onHide, isLoading, data }) => {
    return (
        <Drawer visibility={show} onHide={onHide} title={'History Internal Movement'}>
            <div className={'mt-5 px-6'}>
                {isLoading ? (
                    <div className='flex justify-center items-center'>
                        <Spinner className={'w-5 h-5 border-primary-50'} />
                    </div>
                ) : (
                    <>
                        <div className={'flex flex-col mb-6'}>
                            <p className={'text-md font-bold text-neutral-80 capitalize'}>{data?.name}</p>
                            <p className={'text-md text-neutral-60'}>{data?.nip}</p>
                        </div>

                        {data?.history?.map((item, index) => (
                            <div className={'pb-2 cursor-pointer'} key={index}>
                                <div className={'flex flex-row items-center gap-5'}>
                                    <div
                                        className={`bg-neutral-30 w-5 h-5 rounded-full flex flex-col justify-center items-center`}
                                    >
                                        <div className={'bg-white w-3 h-3 rounded-full'} />
                                    </div>
                                    <p className={'text-neutral-80 font-bold capitalize'}>{item.job_title}</p>
                                </div>
                                <div
                                    className={`text-neutral-70 pb-5 ${index !== data?.history?.length - 1 ? 'border-l-2 border-neutral-30 ml-2 mt-1 pl-8' : 'pl-10'}`}
                                >
                                    <p className={'font-semibold'}>{item.grade}</p>
                                    <p className={'font-semibold capitalize'}>{item.change_type}</p>
                                    <p className={'font-semibold'}>{item.work_duration}</p>
                                    <p className={'font-italic'}>
                                        {formatDateMoment(item.effective_date, 'DD MMMM YYYY')}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </>
                )}
            </div>
        </Drawer>
    )
}
